// 台南 未來捷運路線資料
// tpemrt-v1: #c48c31
// tpemrt-v2: #e3002c
// tpemrt-v3: #f8b61c
// tpemrt-v4: #008659
// tpemrt-v5: #0070bd
// tpemrt-v6: #8246AF
// tpemrt-v7: #FFDB00
// tpemrt-v8: #e5554f

export const lines = [
  //v1
  {
    name: '第一期藍線',
    variant: 'tpemrt-v5',
    info: '設計階段，未核定',
  },
  //v1-1
  // {
  //   name: '第一期藍線延伸線',
  //   variant: 'tpemrt-v5',
  //   info: '尚在進行可行性研究，未核定',
  // },
]

export const stations = [
  [
    {
      name: '大橋 B01',
      address: '',
      lat: 23.019535,
      lng: 120.224519,
    },
    {
      name: '臺南高工 B02',
      address: '',
      lat: 23.013519,
      lng: 120.230974,
    },
    {
      name: '五王 B03',
      address: '',
      lat: 23.008494,
      lng: 120.233957,
    },
    {
      name: '平實轉運站 B04',
      address: '',
      lat: 22.998443,
      lng: 120.234616,
    },
    {
      name: '南紡購物中心 B05',
      address: '',
      lat: 22.992774,
      lng: 120.234078,
    },
    {
      name: '關帝廳 B06',
      address: '',
      lat: 22.984112,
      lng: 120.232214,
    },
    {
      name: '崇學國小 B07',
      address: '',
      lat: 22.97697,
      lng: 120.225742,
    },
    {
      name: '文化中心 B08',
      address: '',
      lat: 22.973571,
      lng: 120.22032,
    },
    {
      name: '虎尾寮 B09',
      address: '',
      lat: 22.97725,
      lng: 120.23455,
    },
    {
      name: '仁德轉運站 B10',
      address: '',
      lat: 22.974742,
      lng: 120.240945,
    },
  ],
  
]
